import { useNavigate } from "react-router-dom";

import { H1 } from "@/components/displayPrimitives/Typography";
import { Button } from "@/components/ui/button";

const Page404: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = (): void => {
    navigate("/");
  };

  return (
    <div className='flex flex-col items-center justify-center h-screen'>
      <H1 className='mb-4 font-semibold text-8xl text-primary'>404</H1>
      <div className='animate-bounce'>
        <svg
          className='w-20 h-20 mx-auto text-primary'
          fill='none'
          viewBox='0 0 24 24'
          stroke='currentColor'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M12 19l9 2-9-18-9 18 9-2zm0 0v-8'
          ></path>
        </svg>
      </div>
      <p className='mb-4 text-2xl text-gray-600'>
        Oops! Looks like you&apos;re lost.
      </p>

      <p className='my-4 text-xl text-gray-600 '>Let&apos;s get you back .</p>
      <Button className='lg:w-[350px]' onClick={() => handleGoBack()}>
        Go Back
      </Button>
    </div>
  );
};

export default Page404;
